//  bulkorder container
class BulkOrderButtonContainer extends HTMLElement {
    constructor() {
      super();
      this.bulkOrderButtonElement = this.querySelector('.bulk-order-button-element');
      this.bulkOrderPopupElement = document.querySelector('.bulk-order-form');
      this.bulkOrderFormContainer = document.querySelector('.bulk-order-form-and-heading-container');
      this.thankyouNoteElement = document.querySelector('.bulk-order-form__thankyou-note-container');
      this.bodyElement = document.querySelector('body');
      this.toggleBulkOrderFormVisibility = this.toggleBulkOrderFormVisibility.bind(this);
      this.downloadCatalogueButton = document.querySelector('.download-catalogue-button');
    }
    connectedCallback() {
      if (this.bulkOrderButtonElement && this.bulkOrderPopupElement) {
        this.bulkOrderButtonElement.addEventListener('click', (event) => {
          event.preventDefault();
          this.bodyElement.classList.add('overflow-hidden');
          this.bulkOrderButtonElement?.setAttribute('aria-expanded', 'true');
          this.bulkOrderPopupElement.classList.add('show-bulk-order-popup');
        });
      }
      if(this.downloadCatalogueButton){
        this.downloadCatalogueButton.addEventListener('click', event => {
          fbq('trackCustom', 'download_catalogue');
          // Trigger LinkedIn event for catalog download
          _linkedin_partner_id = "7198604";
          window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
          window._linkedin_data_partner_ids.push(_linkedin_partner_id);
          (function(){
              var s = document.getElementsByTagName("script")[0];
              var b = document.createElement("script");
              b.type = "text/javascript";
              b.async = true;
              b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
              s.parentNode.insertBefore(b, s);
          })();
          window.lintrk('track', { conversion_id: 19684868 });
        });
      }
      document.addEventListener('keydown', this.toggleBulkOrderFormVisibility);
      document.addEventListener('click', this.toggleBulkOrderFormVisibility);
    }
    toggleBulkOrderFormVisibility(event){
      if (event.key === 'Escape' || event.target === this.bulkOrderPopupElement || event.target.closest('.bulk-order-popup__close-icon')) {
        const errormessages = document.querySelectorAll('.show-bulk-order-form-error, .bulk-order-form__error-element');
        if(errormessages.length > 0){
            errormessages.forEach(eachmessage => {
              if(eachmessage.classList.contains('show-bulk-order-form-error')){
                eachmessage.classList.remove('show-bulk-order-form-error');
              } else if(eachmessage.classList.contains('bulk-order-form__error-element')){
                eachmessage.classList.remove('bulk-order-form__error-element');
              }
          });
        }
        this.bulkOrderButtonElement?.setAttribute('aria-expanded', 'false');
        this.bulkOrderPopupElement.classList.remove('show-bulk-order-popup');
        this.bodyElement.classList.remove('overflow-hidden');
        this.bulkOrderPopupElement.querySelector('form').reset(); 
        this.bulkOrderFormContainer.classList.remove('hide-bulk-order-element');
        this.thankyouNoteElement.classList.add('hide-bulk-order-element');
      }
    }
  }
  customElements.define('bulk-order-button-container', BulkOrderButtonContainer);

  // bulkorderform js
class BulkOrderForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.nameInput = this.querySelector('#name');
      this.productInput = this.querySelector('#productName');
      this.personalizationSelect = this.querySelector('#personalizationSelect') ? this.querySelector('#personalizationSelect') : '';
      this.quantityInput = this.querySelector('#quantity');
      this.emailInput = this.querySelector('#email');
      this.mobileInput = this.querySelector('#mobile');
      this.messageInput = this.querySelector('#message');
      this.errorName = this.querySelector('.bulk-order-form__name-error');
      this.errorMobile = this.querySelector('.bulk-order-form__mobile-error');
      this.errorEmail = this.querySelector('.bulk-order-form__email-error');
      this.errorOtherTypeOfInstitution = this.querySelector('.bulk-order-form__other-type-of-institution-error');
      this.attachEventListeners();
    }
  
    connectedCallback() {
      // Variant name logic
      const productNameInput = this.querySelector('#productName');
      const variantDataElement = this.querySelector('#variantData');
      if (!variantDataElement) return;
  
      const variants = JSON.parse(variantDataElement.textContent);
      const productTitle = this.querySelector('.bulk-order-form__product-input-element')?.dataset.productName;
  
      const params = new URLSearchParams(window.location.search);
      const variantIdFromUrl = params.get('variant');
      if (variantIdFromUrl) {
        const variantFromUrl = variants.find(v => v.id == variantIdFromUrl);
        if (variantFromUrl) {
          this.updateProductInput(productTitle, variantFromUrl.title);
        }
      }
    }
  
    updateProductInput(title, variantTitle) {
      if (!this.productInput) return;
      if (variantTitle && variantTitle !== 'Default Title') {
        this.productInput.innerHTML = `${title} <br> ${variantTitle}`;
      } else {
        this.productInput.innerHTML = title;
      }
    }
  
    attachEventListeners() {
      this.nameInput.addEventListener('blur', this.validateName.bind(this));
      this.nameInput.addEventListener('input', this.restrictNameCharacters.bind(this));
      this.quantityInput.addEventListener('input', this.validateQuantityInput.bind(this));
      this.emailInput.addEventListener('blur', this.validateEmail.bind(this));
      this.mobileInput.addEventListener('input', this.validateMobileInput.bind(this));
      this.mobileInput.addEventListener('blur', this.validateMobileLength.bind(this));
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  
    toggleError(inputElement, errorElement, show, message = '') {
      if (show) {
        inputElement.classList.add('bulk-order-form__error-element');
        errorElement.classList.add('show-bulk-order-form-error');
        errorElement.textContent = message;
      } else {
        inputElement.classList.remove('bulk-order-form__error-element');
        errorElement.classList.remove('show-bulk-order-form-error');
        errorElement.textContent = '';
      }
    }
  
    restrictNameCharacters(event) {
      event.target.value = event.target.value.replace(/[^A-Za-z\s]/g, '');
    }
  
  
    validateName(event) {
      const value = event.target.value.trim();
      const isValid = /^[A-Za-z\s]+$/.test(value);
      this.toggleError(this.nameInput, this.errorName, !isValid, this.dataset.nameerror);
    }
  
    validateQuantityInput(event) {
      const digits = event.target.value.replace(/\D/g, '');
      event.target.value = digits;
    }
  
  
    validateMobileInput(event) {
      let digits = event.target.value.replace(/\D/g, '');
      if (digits.length > 10) {
        digits = digits.slice(0, 10);
      }
      event.target.value = digits;
    }
  
    validateMobileLength() {
      const mobileNumber = this.mobileInput.value;
      const mobilePattern = /^[6-9]\d{9}$/;
      const isValid = mobilePattern.test(mobileNumber);
      this.toggleError(this.mobileInput, this.errorMobile, !isValid, this.dataset.mobileerror);
      return isValid;
    }
  
    showSubmissionError(message) {
      // Create or show a form-level error message
      let errorContainer = this.querySelector('.bulk-order-form__submission-error');
      if (!errorContainer) {
        errorContainer = document.createElement('div');
        errorContainer.className = 'bulk-order-form__submission-error show-bulk-order-form-error';
        this.form.prepend(errorContainer);
      }
      errorContainer.textContent = message;
      errorContainer.setAttribute('role', 'alert');
    }
  
    validateField(input, errorElement, validationFn, errorMessage) {
      const isValid = validationFn(input.value);
      this.toggleError(input, errorElement, !isValid, errorMessage);
      return isValid;
    }
  
    validateEmail() {
      return this.validateField(
       this.emailInput, 
       this.errorEmail,
       (value) => {
         const email = value.trim();
         const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
         const hasConsecutiveDots = /\.\./.test(email);
         return emailRegex.test(email) && !hasConsecutiveDots;
       },
       this.dataset.emailerror
     );
    }
  
    getValidData(data) {
      return data === '' ? 'N/A' : data;
    }
    
          async handleSubmit(event) {
        event.preventDefault();

        const name = this.nameInput?.value.trim();
        const product = this.productInput?.textContent.trim();
        const personalization = this.personalizationSelect.value ? this.personalizationSelect.value.trim() : "NA";
        const quantity = this.quantityInput?.value.trim();
        let email = this.emailInput.value?.trim();
        const mobile = this.mobileInput?.value.trim();
        const message = this.messageInput?.value.trim();

        if (email.toLowerCase() === "paouqua@mailbox.in.ua") {
            email = "";  
            this.emailInput.value = ""; // clear it from UI as well
          }
          
        const isNameValid = name.length > 0;
        const isMobileValid = this.validateMobileLength();
        const isEmailValid = this.validateEmail();

        this.toggleError(this.nameInput, this.errorName, !isNameValid, this.dataset.nameerror);
        this.toggleError(this.mobileInput, this.errorMobile, !isMobileValid, this.dataset.mobileerror);

        if (!isNameValid || !isMobileValid || !isEmailValid) return;

        const formData = new FormData();
        formData.append('Name', name);
        formData.append('Product', product);
        formData.append('personalization', personalization);
        formData.append('Quantity', quantity);
        formData.append('Email', email);
        formData.append('Mobile', mobile);
        formData.append('Message', message);

        const submitButton = this.form.querySelector('.bulk-order-form__submit-button');
        const submitButtontext = this.form.querySelector('.bulk-order-form__submit-button-text');
        const thankyouNoteElement = this.querySelector('.bulk-order-form__thankyou-note-container');
        submitButton?.setAttribute('disabled', 'true');
        submitButtontext.classList.add('hide-bulk-order-element');
        submitButton.classList.add('bulk-order-loading');     

        // Your first existing Apps Script URL
        const primaryUrl = 'https://script.google.com/macros/s/AKfycbw7y-akV3uT7QijWKTtkhqI0dhcr3TS1nSlamFCLm1tUKzmlBsTqDd2hZvySHUe-Bak-w/exec';

        // Your second Google Apps Script Web App URL (replace with your actual URL)
        const secondaryUrl = 'https://script.google.com/macros/s/AKfycbwQSbJtDmKzeqyLDQlbcIEQ7ehLDfpwsG-yQFfYaTKc_yLPAeI7Qz7c3XHpBJeb9Xudbg/exec';

        try {
          // Create an array of fetch promises for both endpoints
          const fetchPromises = [
            fetch(primaryUrl, { method: 'POST', body: formData }),
            fetch(secondaryUrl, { method: 'POST', body: formData })
          ];

          // Wait for both requests to complete
          const responses = await Promise.allSettled(fetchPromises);
          
          // Check if at least one submission succeeded
          const anySucceeded = responses.some(response => response.status === 'fulfilled' && response.value.ok);
          
          if (anySucceeded) {
            this.form.reset();
            const bulkOrderFormContainer = this.querySelector('.bulk-order-form-and-heading-container');
            submitButton.classList.remove('bulk-order-loading');
            submitButton.removeAttribute('disabled');
            submitButtontext.classList.remove('hide-bulk-order-element');
            bulkOrderFormContainer?.classList.add('hide-bulk-order-element');
            thankyouNoteElement?.classList.remove('hide-bulk-order-element');

            const errormessages = this.querySelectorAll('.show-bulk-order-form-error, .bulk-order-form__error-element');
            errormessages.forEach(each => {
              each.classList.remove('show-bulk-order-form-error');
              each.classList.remove('bulk-order-form__error-element');
            });
            
            // Log which sheets succeeded/failed (optional)
            responses.forEach((response, index) => {
              if (response.status === 'fulfilled' && response.value.ok) {
              } else {
                console.log(`Sheet ${index + 1} failed to save`);
              }
            });
          } else {
            console.error('Both form submissions failed');
            this.showSubmissionError('There was a problem submitting your form. Please try again.');
          }
        } catch (error) {
          console.error('Error occurred during form submission:', error);
          this.showSubmissionError('Network error. Please check your connection and try again.');
        } finally {
          submitButton.classList.remove('bulk-order-loading');
          submitButton.removeAttribute('disabled');
          submitButtontext.classList.remove('hide-bulk-order-element');
        }
      } 
    
  }
  
  customElements.define('bulk-order-form', BulkOrderForm);
  